import { useState } from 'react'

const CustomValueHook = (props) => {
    const [state, setState] = useState({ ...props })

    const handleChange = (update) => {
        if (typeof update === 'function') {
            setState((prevState) => ({
                ...prevState,
                ...update(prevState),
            }));
        } else {
            for (let prop in update) {
                setState((prevState) => ({
                    ...prevState, [prop]: update[prop]
                }));
            }
        }
    };

    const handleResetState = () => {
        setState({ ...props })
    }
    return [state, handleChange, handleResetState];
}

export default CustomValueHook;
